import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Project } from '@/types/project.ts'
import type { CreateProject } from '@/model/create-project.model.ts'
import { axiosClient } from '@/utils/axios-client'
import type { Stroom } from '@/types/journey-products'

export const useLegacyProjectStore = defineStore('legacyProjectStore', () => {
  const projects = ref<Project[]>([])
  const projectStromen = ref<Stroom[]>([])

  async function fetchProjects(): Promise<Project[]> {
    const response = await axiosClient.request<Project[]>({
      url: '/idf/api/project/all',
      method: 'GET',
    })

    projects.value = response.data

    return response.data
  }

  async function fetchProjectStromen(uuid: string): Promise<Stroom[]> {
    const response = await axiosClient.request<Stroom[]>({
      url: `idf/api/stroom/project/${uuid}`,
      method: 'GET',
    })

    projectStromen.value = response.data

    return response.data
  }

  async function createProject(project: CreateProject): Promise<Project> {
    const response = await axiosClient.request<Project>({
      url: '/idf/api/project',
      method: 'POST',
      data: project,
    })

    projects.value.push(response.data)
    return response.data
  }

  function lastCreatedProjectStroomName(): string {
    if (projectStromen.value.length < 1) return ''

    const lastCreatedStroom = projectStromen.value.reduce((latest, current) =>
      new Date(current.createdDate) > new Date(latest.createdDate) ? current : latest
    )
    return lastCreatedStroom?.stroomName
  }

  return {
    projects,
    projectStromen,
    createProject,
    fetchProjectStromen,
    lastCreatedProjectStroomName,
    fetchProjects,
  }
})
